import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LazyLoadScriptService } from './../sidebar/lazy-load-script.service'
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-setting',
    templateUrl: './settings.component.html'
})

export class SettingComponent implements OnInit {
    imageoneSetting: boolean = false;
    pageTitle: string;
    pageDisplay: string;

    constructor(
        private activatedroute: ActivatedRoute,
        private router: Router,
        private lazyLoadService: LazyLoadScriptService
    ) { }

    ngOnInit(): void {
        var applicationName = "settingappelement";
        
        this.lazyLoadService.loadScript(environment["SETTINGAPPURL"], applicationName).subscribe(_ => {
            let url = this.router.url;
            if (url == '/permissions' || url.includes('/permissions/user/')) {
                this.pageTitle = "Permissions";
                this.pageDisplay = "permissions";
            } 
            else if (url == '/individual-permissions') {
                this.pageTitle = "User Preferences";
                this.pageDisplay = "individualPermissions";
            } 
            else if (url == '/preferences') {
                this.pageTitle = "User Preferences";
                this.pageDisplay = "preferences";
            }
            else if (url == '/configuration') {
                this.pageTitle = "Configuration";
                this.pageDisplay = "configuration";
            }
            console.info('Page Display:',this.pageDisplay);
            this.imageoneSetting = true;
        });

    }

    ngOnDestroy(): void {
        this.imageoneSetting = false;
    }
}